import { VendorDTO } from "../DTO/vendorDTO";
import { Address } from "./address";

export class Vendor{
    public id! : number;
    public name! : string;
    public canCreateMoovs! : boolean;
    public addressList!: Address[];
    public premierPartnerIdList!: number[];
    public billingBucketIdList!: number[];
    public billingCustomerId?:string;
    public deleted? : boolean;
    public added? : Date;

    constructor(){
        this.addressList = new Array();
        this.premierPartnerIdList = new Array();
        this.billingBucketIdList = new Array();
    }

    public static mapFromDTO(param:VendorDTO):Vendor{ 
        if (!param) throw new Error("parameter is null")
        let obj = new Vendor();
        try
        {
            obj.id = param.id;
            obj.name = param.name;
            obj.addressList = param.addressList.map(dto=>Address.mapFromDTO(dto));
            obj.premierPartnerIdList = param.premierPartnerIdList;
            obj.billingBucketIdList = param.billingBucketIdList;
            obj.billingCustomerId = param.billingCustomerId;
            obj.deleted = param.deleted;
            obj.canCreateMoovs = param.canCreateMoovs;
            if(param.added) obj.added = new Date(param.added);
            
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    public static mapToDTO(param:Vendor):VendorDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new VendorDTO();
        try
        {
            dto.id = param.id;
            dto.name = param.name;
            dto.addressList = param.addressList.map(adr=>Address.mapToDTO(adr));
            dto.premierPartnerIdList = param.premierPartnerIdList;
            dto.billingBucketIdList = param.billingBucketIdList;
            dto.billingCustomerId = param.billingCustomerId;
            dto.deleted = param.deleted;
            dto.canCreateMoovs = param.canCreateMoovs;
            if(param.added) dto.added = param.added.toISOString();
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }

    public addAddress(address:Address){
        //currently we only support one address per customer. address.type=0
        this.addressList.push(address)
    }

    get address(){
        //currently we only support one address per customer. address.type=0
        return this.addressList?.length>0?this.addressList[0]:undefined;
    }

    get formattedAddress(){
        //currently we only support one address per customer. address.type=0
        return this.addressList?.length>0?this.addressList[0].formattedAddress:undefined;
    }

    get status():string{
        return this.deleted?"Inactive":"Active";
    }
}